// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 300px;
}

.text-primary {
  color: #3f51b5;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluYWN0aXZpdHktbW9kYWwuY29tcG9uZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNJO0VBQVEsY0FBQTtFQUFnQixnQkFBQTtBQUU1Qjs7QUFESTtFQUFnQixjQUFBO0FBS3BCIiwiZmlsZSI6ImluYWN0aXZpdHktbW9kYWwuY29tcG9uZW50LnRzIiwic291cmNlc0NvbnRlbnQiOlsiXG4gICAgOmhvc3QgeyBkaXNwbGF5OiBibG9jazsgbWluLXdpZHRoOiAzMDBweDsgfVxuICAgIC50ZXh0LXByaW1hcnkgeyBjb2xvcjogIzNmNTFiNTsgfVxuICAiXX0= */`, "",{"version":3,"sources":["webpack://./src/app/core/auth/inactivity-modal/inactivity-modal.component.ts"],"names":[],"mappings":"AACI;EAAQ,cAAA;EAAgB,gBAAA;AAE5B;;AADI;EAAgB,cAAA;AAKpB;AACA,wbAAwb","sourcesContent":["\n    :host { display: block; min-width: 300px; }\n    .text-primary { color: #3f51b5; }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
